import React, { FC, useEffect } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

interface IChartPie {
  members: { country: string; amount: number }[];
  list: {
    Email?: string;
    Name?: string;
    Country?: string;
    Flag?: string;
  }[];
}

ChartJS.register(ArcElement, Tooltip, Legend);

const ChartPie: FC<IChartPie> = ({ members, list }): React.ReactElement => {
  const [chartData, setChartData] = React.useState({
    labels: [],
    datasets: [
      {
        label: '# of Votes',
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: [
          '#1142AA',
          '#6C8DD5',
          '#3714B0',
          '#1F0772',
          '#1F0723',
          '#009B95',
          '#33CDC7',
          '#FFA900',
          '#C6F500',
          '#800053',
          '#9261FA',
        ],
        borderColor: [
          '#1142AA',
          '#6C8DD5',
          '#3714B0',
          '#1F0772',
          '#1F0723',
          '#009B95',
          '#33CDC7',
          '#FFA900',
          '#C6F500',
          '#800053',
          '#9261FA',
        ],
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    let amountOfAllArray: { country: string; percent: number }[] = [];

    members.length &&
      members.slice().forEach((item) => {
        const calculateItem = Math.fround((item.amount / list.length) * 100).toFixed(1);
        amountOfAllArray.push({ country: item.country, percent: +calculateItem });
      });

    const top10: { country: string; percent: number }[] = amountOfAllArray
      .sort((a, b) => b.percent - a.percent)
      .slice(0, 10);
    const rest: { country: string; percent: number } = {
      country: 'Others countries    ',
      percent: amountOfAllArray.slice(11).reduce((acc, item) => acc + item.percent, 0),
    };

    amountOfAllArray = [...top10, rest];

    setChartData({
      ...chartData,
      //@ts-ignore
      labels: amountOfAllArray.map((item) => item.country),
      datasets: [
        {
          ...chartData.datasets[0],
          data: amountOfAllArray.map((item) => item.percent),
        },
      ],
    });
  }, []);

  return (
    <Doughnut
      data={chartData}
      options={{
        responsive: true,
        plugins: {
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                return tooltipItem.label.trim() + ': ' + tooltipItem.formattedValue + '%';
              },
            },
          },
          legend: {
            onClick: function () {
              return false;
            },
            fullSize: true,
            display: true,
            position: 'left',
            labels: {
              usePointStyle: true,
              boxHeight: 18,
              color: '',
              font: {
                family: 'Montserrat',
              },
            },
          },
        },
      }}
      plugins={[
        //@ts-ignore
        {
          beforeDraw: function (chart) {
            const width = chart.width,
              height = chart.height,
              ctx = chart.ctx;
            ctx.restore();
            const fontSize = (width / 250).toFixed(2);
            ctx.font = fontSize + 'em Montserrat';
            //@ts-ignore
            ctx.textBaseline = 'center';
            const text = String(list.length),
              textX = Math.round((width - ctx.measureText(text).width) / 1.49),
              textY = height / 2.1;
            ctx.fillText(text, textX, textY);
            ctx.save();
          },
        },
        //@ts-ignore
        {
          beforeDraw: function (chart) {
            const width = chart.width,
              height = chart.height,
              ctx = chart.ctx;
            ctx.restore();
            const fontSize = (width / 400).toFixed(2);
            ctx.font = fontSize + 'em Montserrat';
            //@ts-ignore
            ctx.textBaseline = 'center';
            const text = 'COMPANIES',
              textX = Math.round((width - ctx.measureText(text).width) / 1.4),
              textY = height / 1.9;
            ctx.fillText(text, textX, textY);
            ctx.save();
          },
        },
      ]}
    />
  );
};

export default ChartPie;
